import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { Logo } from '../ui';
import { ThemeToggle } from '../app/ThemeToggle';

/** A calm, centred frame for pages outside the app shell. */
export function AuthFrame({ children, wide }: { children: ReactNode; wide?: boolean }) {
  return (
    <div className="auth-frame">
      <header className="auth-frame__top">
        <Link to="/" aria-label="CertiHash home" style={{ textDecoration: 'none' }}>
          <Logo />
        </Link>
        <ThemeToggle />
      </header>
      <main id="main" className={`auth-frame__main${wide ? ' auth-frame__main--wide' : ''}`}>
        {children}
      </main>
    </div>
  );
}

export function AuthCard({ icon, tone, title, children }: { icon?: ReactNode; tone?: 'ok' | 'crit' | 'warn' | 'accent'; title: ReactNode; children: ReactNode }) {
  return (
    <section className="auth-card">
      {icon && <div className={`auth-card__icon${tone ? ` auth-card__icon--${tone}` : ''}`}>{icon}</div>}
      <h1 className="auth-card__title">{title}</h1>
      <div className="auth-card__body">{children}</div>
    </section>
  );
}
